"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { Loader2, Trash2 } from "lucide-react"
import { toast } from "sonner"
import { cn } from "@/lib/utils"
import { removeAutoTradingStock } from "@/lib/api/autotrading"

interface RemoveFromAutoTradingListButtonProps {
  stockCode: string
  stockName: string
  className?: string
}

export function RemoveFromAutoTradingListButton({
  stockCode,
  stockName,
  className,
}: RemoveFromAutoTradingListButtonProps) {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: () => removeAutoTradingStock(stockCode),
    onSuccess: () => {
      toast.success("자동매매 대상에서 제거되었습니다")
      queryClient.invalidateQueries({ queryKey: ["autotrading", "stocks"] })
      queryClient.invalidateQueries({ queryKey: ["backtest", "watchlist"] })
    },
    onError: () => {
      toast.error("제거에 실패했습니다")
    },
  })

  return (
    <button
      type="button"
      disabled={mutation.isPending}
      title="자동매매 목록에서 제거"
      onClick={(e) => {
        e.stopPropagation()
        if (window.confirm(`${stockName}(${stockCode})을(를) 자동매매 목록에서 제거할까요?`)) {
          mutation.mutate()
        }
      }}
      className={cn(
        "inline-flex size-7 shrink-0 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-red-500/10 hover:text-red-400",
        className
      )}
    >
      {mutation.isPending ? (
        <Loader2 className="size-4 animate-spin" />
      ) : (
        <Trash2 className="size-4" />
      )}
    </button>
  )
}
